import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { FileText, Shield, User, CreditCard, Scale, Mail } from "lucide-react";
const TermsOfService = () => {
  return <div className="min-h-screen flex flex-col">
    <Navigation />

    <main className="flex-1">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-primary/5 to-transparent pt-4 pb-4">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center space-y-4">
            {/* Removed the icon */}
            <h1 className="text-4xl md:text-5xl font-bold text-foreground">
              Terms of Service
            </h1>
            <p className="text-lg text-muted-foreground">
              Last Updated: October 24, 2025
            </p>
            <p className="text-base text-muted-foreground max-w-2xl mx-auto">
              By accessing or using the services provided by RenewSantulan Advisory, you agree to comply with
              and be bound by the following Terms of Service. If you do not agree with any part of these terms,
              please do not use our services or website.
            </p>
          </div>
        </div>
      </section>



      {/* Terms Content */}
      <section className="px-4 sm:px-6 py-8 sm:py-12">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto space-y-8">

            {/* Section 1 */}
            <div className="card-enhanced rounded-xl p-8 space-y-4">
              <div className="flex items-start gap-4">

                <div className="flex-1 space-y-3">
                  <h2 className="text-2xl font-semibold text-foreground">
                    1. Acceptance of Terms
                  </h2>
                  <p className="text-muted-foreground leading-relaxed">
                    By using RenewSantulan's website, consultations, or programs, you confirm that you have read,
                    understood, and accepted these terms. These terms govern your use of our website, services,
                    and digital content.
                  </p>
                </div>
              </div>
            </div>

            {/* Section 2 */}
            <div className="card-enhanced rounded-xl p-8 space-y-4">
              <div className="flex items-start gap-4">

                <div className="flex-1 space-y-3">
                  <h2 className="text-2xl font-semibold text-foreground">
                    2. Nature of Services
                  </h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Our services include personalized nutrition counseling, lifestyle coaching, health consultations,
                    meal plans, and wellness programs. The information provided is for educational and informational
                    purposes only.
                  </p>
                  <p className="text-muted-foreground leading-relaxed font-medium">
                    It is not a substitute for professional medical advice, diagnosis, or treatment. Always consult
                    a qualified healthcare professional regarding any medical condition, symptoms, or treatment options.
                  </p>
                </div>
              </div>
            </div>

            {/* Section 3 */}
            <div className="card-enhanced rounded-xl p-8 space-y-4">
              <div className="flex items-start gap-4">

                <div className="flex-1 space-y-3">
                  <h2 className="text-2xl font-semibold text-foreground">
                    3. User Responsibilities
                  </h2>
                  <ul className="space-y-2 ml-4">
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1.5">•</span>
                      <span className="text-muted-foreground">
                        You agree to provide accurate and complete information regarding your health, lifestyle,
                        medications, and medical history.
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1.5">•</span>
                      <span className="text-muted-foreground">
                        You agree to follow the recommended program responsibly and notify your healthcare provider
                        about any changes in your health.
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1.5">•</span>
                      <span className="text-muted-foreground">
                        You acknowledge that results may vary based on adherence, individual health conditions,
                        and lifestyle factors.
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Section 4 */}
            <div className="card-enhanced rounded-xl p-8 space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">
                4. Intellectual Property
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                All content, materials, images, logos, and information provided by RenewSantulan are the intellectual
                property of RenewSantulan Advisory. You may view, download, or print materials for personal use only.
                Reproduction, distribution, or commercial use without prior written permission is strictly prohibited.
              </p>
            </div>

            {/* Section 5 */}
            <div className="card-enhanced rounded-xl p-8 space-y-4">
              <div className="flex items-start gap-4">

                <div className="flex-1 space-y-3">
                  <h2 className="text-2xl font-semibold text-foreground">
                    5. Payment and Refunds
                  </h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Program fees, consultation charges, and any other payments are communicated upfront. Refunds are
                    subject to our discretion. By making a payment, you agree to comply with our pricing and payment terms.
                  </p>
                </div>
              </div>
            </div>

            {/* Section 6 */}
            <div className="card-enhanced rounded-xl p-8 space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">
                6. Limitation of Liability
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                RenewSantulan is not liable for:
              </p>
              <ul className="space-y-2 ml-4">
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1.5">•</span>
                  <span className="text-muted-foreground">
                    Any direct, indirect, or consequential damages arising from the use of our services.
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1.5">•</span>
                  <span className="text-muted-foreground">
                    Health outcomes resulting from adherence or non-adherence to our recommendations.
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1.5">•</span>
                  <span className="text-muted-foreground">
                    Any reliance on information provided via our website, emails, or consultations.
                  </span>
                </li>
              </ul>
            </div>

            {/* Section 7 */}
            <div className="card-enhanced rounded-xl p-8 space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">
                7. Privacy and Data Protection
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                We collect and process personal data in accordance with our Privacy Policy. By using our services,
                you consent to the collection, use, and storage of your personal information as described in our policy.
              </p>
            </div>

            {/* Section 8 */}
            <div className="card-enhanced rounded-xl p-8 space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">
                8. Cancellation and Rescheduling
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                Appointments may be cancelled or rescheduled with 24-hour notice. Emergency situations are handled
                on a case-by-case basis.
              </p>
            </div>

            {/* Section 9 */}
            <div className="card-enhanced rounded-xl p-8 space-y-4">
              <div className="flex items-start gap-4">

                <div className="flex-1 space-y-3">
                  <h2 className="text-2xl font-semibold text-foreground">
                    9. Governing Law
                  </h2>
                  <p className="text-muted-foreground leading-relaxed">
                    These terms are governed by the laws of India. Any disputes arising out of these terms will be
                    subject to the exclusive jurisdiction of courts in Gurugram, Haryana.
                  </p>
                </div>
              </div>
            </div>

            {/* Section 10 - Contact */}
            <div className="card-enhanced rounded-xl p-8 space-y-4">
              <div className="flex items-start gap-4">

                <div className="flex-1 space-y-3">
                  <h2 className="text-2xl font-semibold text-foreground">
                    10. Contact Information
                  </h2>
                  <p className="text-muted-foreground leading-relaxed">
                    For questions regarding these Terms of Service or our practices, please contact us at:
                  </p>
                  <div className="space-y-2">
                    <p className="text-muted-foreground">
                      <strong className="text-foreground">Email:</strong>{" "}
                      <a href="mailto:renewsantulan@gmail.com" className="text-primary hover:underline">
                        renewsantulan@gmail.com
                      </a>
                    </p>
                    <p className="text-muted-foreground">
                      <strong className="text-foreground">Phone:</strong>{" "}
                      <a href="tel:+919910961228" className="text-primary hover:underline">
                        +91 99109 61228
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact CTA */}
            <div className="card-enhanced rounded-xl p-8 text-center space-y-4 bg-gradient-to-br from-primary/5 to-accent/5">
              <h3 className="text-2xl font-semibold text-foreground">
                Questions About Our Terms?
              </h3>
              <p className="text-muted-foreground">
                If you have any questions or concerns about our terms of service, please don't hesitate to reach out.
              </p>
              <a href="https://wa.me/919910961228" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors font-medium">
                Contact Us
              </a>
            </div>

          </div>
        </div>
      </section>
    </main>

    <Footer />
  </div>;
};
export default TermsOfService;